import { render } from "./IconElectraMotor.vue?vue&type=template&id=af627252"
import script from "./IconElectraMotor.vue?vue&type=script&lang=js"
export * from "./IconElectraMotor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__